export default __webpack_public_path__ + "static/media/Account.0b002e58.jpg";